

let doneInit = false;
let allowCookies = false;
let doneStartingName = false;
let startingName = null;

const config = require('../config');
const { state } = require('./state');

deleteCookie("traitorsName");
deleteCookie("io");

function fetchStartingNameFromServer() {
	if (doneInit && allowCookies && !doneStartingName) {
		doneStartingName = true;
		const userId = getCookie("traitorsId");
		state.userId = userId;

		if (userId && userId.length > 0) {

			const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
			const body = JSON.stringify({ userId: userId });
			const fetchParams = {
				method: 'POST',
				headers: headers,
				body: body,
			};

			const finishFunction = function(data) {
				if (data.name)
					startingName = data.name;
			}

			fetch(`${config.BACKEND_URL}/api/getUserRank`, fetchParams)
				.then(response => response.json())
				.then(finishFunction);
		}
	}
}

function getStartingName() {
	return startingName;
}

function getAllowCookies() {
	return allowCookies;
}

function hasDoneCookieInit() {

	if (!doneInit) {
		const consentCookie = getCookie("traitorsConsent");
		if (consentCookie) {
			doneInit = true;
			if (consentCookie == "true") {
				allowCookies = true;
				fetchStartingNameFromServer();
			} else  {
				allowCookies = false;
				deleteCookie("traitorsId");
			}
		}
	}

	return doneInit;
}

function setAllowCookies(inAllowCookies) {

	const needToReload = doneInit && inAllowCookies != allowCookies;

	doneInit = true;
	allowCookies = inAllowCookies;

	setCookie("traitorsConsent", inAllowCookies, 365, false);

	if (!allowCookies) {

		let userId = getCookie("traitorsId");
		if (state.signedIn)
			userId = state.userId;

		deleteCookie("traitorsId");
		
		if (userId && userId.length > 0) {
			const headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
			const body = JSON.stringify({ userId: userId });
			const fetchParams = {
				method: 'POST',
				headers: headers,
				body: body,
			};
			fetch(`${config.BACKEND_URL}/api/deleteUser`, fetchParams);
		}

	} else {
		fetchStartingNameFromServer();
	}

	if (needToReload)
		location.reload();
}

function deleteCookie(name) {
	document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days, requiresConsent = true) {

	if (!allowCookies && requiresConsent)
		return;

	var d = new Date();
	d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
	document.cookie = name + "=" + value + ";path=/;expires=" + d.toUTCString();
}

module.exports = {
  getCookie,
  setCookie,
  hasDoneCookieInit,
  setAllowCookies,
  getAllowCookies,
  getStartingName,
}
